export interface ColumnConfig {
  key: string;
  label: string;
  sortable: boolean;
  tooltip: string;
  type?: string;
}

export const DEFAULT_COLUMNS: ColumnConfig[] = [
  { key: 'id', label: 'ID', sortable: true, tooltip: 'ID da obra' },
  { key: 'modulos',  label: 'M\u00F3dulo', sortable: true, type: 'tag', tooltip: 'Tipo da obra' },
  { key: 'ufCidade', label: 'UF/Cidade', sortable: true, tooltip: 'Estado/Cidade' },
  { key: 'empresa', label: 'Empresa', sortable: true, tooltip: 'Nome da empresa' },
  { key: 'obra', label: 'Obra', sortable: true, tooltip: 'Nome da obra' },
  { key: 'fase', label: 'Fase', sortable: true, tooltip: 'Fase da obra' },
  { key: 'tipo', label: 'Tipo', sortable: true, type: 'tag', tooltip: 'Tipo da obra' },
  { key: 'valor', label: 'Valor', sortable: true, tooltip: 'Valor da obra' },
  { key: 'padrao', label: 'Padr\u00E3o', sortable: true, tooltip: 'Padrão da obra' },
  { key: 'res', label: 'Res', sortable: true, tooltip: 'Responsável' },
  { key: 'atualizada', label: 'Data', sortable: true,  tooltip: 'Data da \u00DAltima atualiza\u00E7\u00E3o' },
];